import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Stack } from '@mui/material'
import { useServices } from 'cng-web-lib'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import PasswordUrls from 'src/apiUrls/PasswordUrls'
import * as yup from 'yup'
import { Field, FormActions, FormTitle } from '../components'
import { useTranslations } from "./useTranslations"

export const UpdatePasswordPage = () => {
  const translatedTextsObject = useTranslations()
  const [loading, setLoading] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const { createRecord } = useServices()
  const history = useHistory()

  const form = useForm({
    defaultValues: {
      username: '',
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    },
    resolver: yupResolver(yup.object({
      username: yup.string()
        .required(translatedTextsObject.errorMessage6),
      oldPassword: yup.string()
        .required(translatedTextsObject.errorMessage2),
      newPassword: yup.string()
        .required(translatedTextsObject.errorMessage3)
        .min(12, translatedTextsObject.errorMessage16)
        .max(24, translatedTextsObject.errorMessage16),
      confirmNewPassword: yup.string()
        .required(translatedTextsObject.errorMessage4)
        .min(12, translatedTextsObject.errorMessage17)
        .max(24, translatedTextsObject.errorMessage17)
        .oneOf([yup.ref('newPassword'), null], translatedTextsObject.errorMessage5)
    }))
  })

  const onSubmit = data => {
    setLoading(true)
    createRecord.execute(PasswordUrls.CHANGE_PASSWORD, data,
      (result) => {
        if (!!result) {
          const { error, status, code } = result

          if (status === 'Success' && code === '200') {
            enqueueSnackbar(
              translatedTextsObject.helpText3 + data?.username + "," + translatedTextsObject.helpText4,
              { variant: 'success' }
            )
            history.push('/login')
          } else if (status === 'fail') {
            enqueueSnackbar(
              error + '',
              { variant: 'error' }
            )
            setLoading(false)
          }
        }
      },
      (error) => {
        console.log(error)
        enqueueSnackbar(
          error + '',
          { variant: 'error' }
        )
        setLoading(false)
      }
    )
  }

  const handleErrors = () => enqueueSnackbar('Please fix the errors in the form.', { variant: 'error' })

  return <FormProvider {...form}>
    <FormTitle id="changePasswordTitle">{translatedTextsObject.changePassword}</FormTitle>


    <Stack gap='1.5rem'>
      <Field label={translatedTextsObject.userId}
        name='username' required
        disabled={loading}
        inputProps={{ maxLength: 50 }}
      />
      <Field label={translatedTextsObject.oldPassword}
        name='oldPassword' type="password"
        required disabled={loading}
        inputProps={{ maxLength: 24 }}
      />
      <Field label={translatedTextsObject.newPassword}
        name='newPassword' type="password"
        required disabled={loading}
        inputProps={{ maxLength: 24 }}
        helperText={<>
          {translatedTextsObject.helpText1}&nbsp;
          {translatedTextsObject.helpText2}
        </>}
      />
      <Field label={translatedTextsObject.confirmNewPassword}
        name='confirmNewPassword' type="password"
        required disabled={loading}
        inputProps={{ maxLength: 24 }}
      />
    </Stack>

    <FormActions>
      <Button variant='outlined'
        fullWidth id="backToLogin"
        onClick={() => history.goBack()}
        disabled={loading}
      >
        Cancel
      </Button>
      <Button type='submit' variant='contained'
        fullWidth id="submitButton"
        onClick={form.handleSubmit(onSubmit, handleErrors)}
        disabled={loading}
        startIcon={loading
          ? <FontAwesomeIcon icon={faSpinnerThird} spin />
          : null
        }
      >
        {translatedTextsObject.setNewPassword}
      </Button>
    </FormActions>

  </FormProvider>
}